import {Helmet} from '@dr.pogodin/react-helmet';

import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';
import {formatDocumentTitle} from '@dms/shared';

import {PromoPhotosForm} from '../../components/PromoPhotosForm/PromoPhotosForm';

export function PromoPhotoCreate() {
  return (
    <>
      <Helmet
        title={formatDocumentTitle(
          i18n.t('page.salesSettings.labels.newPromoPhoto'),
          i18n.t('page.salesSettings.labels.promotionalPhotos'),
          i18n.t('page.salesSettings.labels.advertising'),
          i18n.t('page.settings.labels.title')
        )}
      />
      <SettingsTemplate
        header={{
          breadcrumbs: [
            {
              label: i18n.t('page.salesSettings.labels.advertising'),
              href: settingsRoutes.advertising,
            },
            {
              label: i18n.t('page.salesSettings.labels.promotionalPhotos'),
              href: settingsRoutes.advertisingPromoPhotos,
            },
          ],
        }}
        data-testid="settings-advertising-promoPhotos-create"
      >
        <PromoPhotosForm />
      </SettingsTemplate>
    </>
  );
}
